import { useMemo } from 'react';
import { Paper, Stack } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import {
  gridDetailPanelExpandedRowIdsSelector,
  GridRow,
  GridRowProps,
  useGridApiContext,
  useGridSelector,
} from '@rossum/ui/x-data-grid-pro';

export const ROW_HEIGHT = 44;
export const ROW_SPACING = 8;

export const Row = (props: GridRowProps) => {
  const apiRef = useGridApiContext();

  const expandedRowIds = useGridSelector(
    apiRef,
    gridDetailPanelExpandedRowIdsSelector
  );

  const isExpanded = useMemo(
    () => expandedRowIds.has(props.rowId),
    [expandedRowIds, props.rowId]
  );

  return (
    <Stack
      sx={{
        [isExpanded ? 'pt' : 'py']: `${ROW_SPACING / 2}px`,
      }}
    >
      <Stack
        component={Paper}
        sx={{
          borderRadius: borderRadius('m'),
          ...(isExpanded
            ? {
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
                borderBottomColor: 'transparent',
              }
            : undefined),
        }}
      >
        <GridRow {...props} rowHeight={ROW_HEIGHT} />
      </Stack>
    </Stack>
  );
};
